import fetch from "cross-fetch";
import { isProduction } from "../utils/is-production";
import { APIError, defaultError } from "./api-error";

export type HubspotField = {
  name: string;
  value: string;
};

export type HubspotPayAsYouGoFormRequestBody = {
  fields: HubspotField[];
};

export const hubspotPayAsYouGoForm = async (
  body: HubspotPayAsYouGoFormRequestBody
): Promise<any> => {
  const id = process.env.NEXT_PUBLIC_HUBSPOT_PAY_AS_YOU_GO_FORM_ID;

  if (!id || !isProduction()) return;

  const res = await fetch(
    `https://api.hsforms.com/submissions/v3/integration/submit/${id}`,
    {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "content-type": "application/json",
      },
    }
  );
  if (!res.ok) throw new APIError(500, defaultError);

  return res.json();
};
